import { TemplateService } from "../../services/template.service";
import { ApiService } from "../../services/api.service";
import { TranslateService } from "@ngx-translate/core";
import { SubSink } from "subsink";
import { CALENDAR_LOCALE } from "../../services/constant";
import { Chart } from 'chart.js';
import * as _ from 'lodash';
import * as moment from "moment";
import { HttpParams } from "@angular/common/http";
import { DownloadService } from "../download/download.service";
var DocumentRequestDashboardComponent = (function () {
    function DocumentRequestDashboardComponent(apiService, translate, template, downloadService) {
        this.apiService = apiService;
        this.translate = translate;
        this.template = template;
        this.downloadService = downloadService;
        this.subs = new SubSink();
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.totalItems = 0;
        this.loading_main = false;
        this.datastatus = [];
        this.selectedCustomercode = null;
        this.deliverycodeList = null;
        this.allDeliverycodeList = [];
        this.startDate = null;
        this.endDate = null;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.sortBy = null;
        this.sortMode = null;
        this.checkdate = null;
        this.documentNumber = '';
        this.documentList = [];
        this.tableCol = [];
        this.defaultLabel = null;
    }
    DocumentRequestDashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadDataShow();
        this.translate.onLangChange.subscribe(function (event) {
            _this.loadTexts();
        });
        this.getEmailReport();
        // this.loadTexts();
        // this.getDocumentRequestList();
    };
    DocumentRequestDashboardComponent.prototype.getEmailReport = function () {
        var _this = this;
        this.loading_main = true;
        this.rdDocumentType = this.template.getDropdown();
        this.data = this.downloadService.getDocumentRequestList().subscribe(function (res) {
            _this.emailTotal = res.count;
            _this.transactions_approve = res.approved;
            _this.transactions_rejected = res.rejected;
            _this.transactions_pending = res.pending;
            _this.loading_main = false;
            _this.generateChart();
            _this.getTreeTableValue();
            _this.loadTexts();
        });
    };
    DocumentRequestDashboardComponent.prototype.loadTexts = function () {
        var _this = this;
        this.defaultLabel = this.translate.instant('COMMON.ALL');
        this.selectedCustomercode = null;
        this.customercode = null;
        this.selectedRdDocumentType = null;
        this.customercode = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.downloadService.getDocumentRequestList().subscribe(function (result) {
            _.forEach(result.results, function (obj) {
                _this.customercode.push({
                    label: obj.customer_code,
                    value: obj.customer_code
                });
            });
        }, function (error) { return error(status); });
        this.startDate = new Date();
        this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
        this.endDate = new Date();
    };
    DocumentRequestDashboardComponent.prototype.getTreeTableValue = function () {
        this.treeTableValue = {
            'data': [
                {
                    'data': {
                        'name': 'Documents',
                        'size': '75kb',
                        'type': 'Folder'
                    },
                    'children': [
                        {
                            'data': {
                                'name': 'Work',
                                'size': '55kb',
                                'type': 'Folder'
                            },
                            'children': [
                                {
                                    'data': {
                                        'name': 'Expenses.doc',
                                        'size': '30kb',
                                        'type': 'Document'
                                    }
                                },
                                {
                                    'data': {
                                        'name': 'Resume.doc',
                                        'size': '25kb',
                                        'type': 'Resume'
                                    }
                                }
                            ]
                        },
                        {
                            'data': {
                                'name': 'Home',
                                'size': '20kb',
                                'type': 'Folder'
                            },
                            'children': [
                                {
                                    'data': {
                                        'name': 'Invoices',
                                        'size': '20kb',
                                        'type': 'Text'
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    'data': {
                        'name': 'Pictures',
                        'size': '150kb',
                        'type': 'Folder'
                    },
                    'children': [
                        {
                            'data': {
                                'name': 'barcelona.jpg',
                                'size': '90kb',
                                'type': 'Picture'
                            }
                        },
                        {
                            'data': {
                                'name': 'primeui.png',
                                'size': '30kb',
                                'type': 'Picture'
                            }
                        },
                        {
                            'data': {
                                'name': 'optimus.jpg',
                                'size': '30kb',
                                'type': 'Picture'
                            }
                        }
                    ]
                }
            ]
        };
    };
    DocumentRequestDashboardComponent.prototype.generateChart = function () {
        var keepchart = this.transactions_approve + this.transactions_rejected + this.transactions_pending;
        this.ApproveChart = new Chart('ApproveChart', {
            type: 'doughnut',
            data: {
                // labels: ['Red', 'Blue', 'Yellow'],
                datasets: [{
                        label: 'Sent Chart',
                        data: [this.transactions_approve, this.emailTotal],
                        backgroundColor: [
                            '#16c8c8',
                            '#5b5a5a',
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed',
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                responsive: true,
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
        this.RejectedChart = new Chart('RejectedChart', {
            type: 'doughnut',
            data: {
                // labels: ['Red', 'Blue', 'Yellow'],
                datasets: [{
                        label: '# of Votes',
                        data: [this.transactions_rejected, this.emailTotal],
                        backgroundColor: [
                            '#FF6384',
                            '#6F6E6E'
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed',
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
        this.pendingChart = new Chart('pendingChart', {
            type: 'doughnut',
            data: {
                // labels: ['Red', 'Blue', 'Yellow'],
                datasets: [{
                        label: 'pendingChart',
                        data: [this.transactions_pending, this.emailTotal],
                        backgroundColor: [
                            '#FADA3A',
                            '#6F6E6E'
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed',
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
    };
    DocumentRequestDashboardComponent.prototype.pageChanged = function () {
        this.getDocumentRequestList(this.currentPage);
    };
    DocumentRequestDashboardComponent.prototype.setPageSide = function () {
    };
    DocumentRequestDashboardComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    DocumentRequestDashboardComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.getDocumentRequestList();
    };
    DocumentRequestDashboardComponent.prototype.sentdate = function () {
        this.checkdate = 1;
    };
    DocumentRequestDashboardComponent.prototype.getDocumentRequestList = function (page) {
        var _this = this;
        this.tableCol = [];
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.datastatus = [];
        this.loading_main = true;
        var keepstartDate = moment(this.startDate).format('YYYY-MM-DD');
        var keependDate = moment(this.endDate).format('YYYY-MM-DD');
        var params = new HttpParams();
        if (this.selectedCustomercode && this.selectedRdDocumentType) {
            params = params.append('customer_code', this.selectedCustomercode);
            params = params.append('rd_doc_type', this.selectedRdDocumentType);
        }
        if (this.selectedCustomercode) {
            params = params.append('customer_code', this.selectedCustomercode);
        }
        if (this.selectedRdDocumentType) {
            params = params.append('rd_doc_type', this.selectedRdDocumentType);
        }
        if (this.email) {
            params = params.append('email', this.email);
        }
        if (this.documentnum) {
            params = params.append('document_number', this.documentnum);
        }
        if (this.checkdate == 1) {
            params = params.append('document_start_date', keepstartDate);
            params = params.append('document_end_date', keependDate);
        }
        params = params.append('page', this.currentPage.toString());
        params = params.append('page_size', this.itemsPerPage.toString());
        this.downloadService.getDocumentRequestList(params).subscribe(function (result) {
            _.forEach(result.results, function (obj) {
                _this.totalItems = result.count;
                _this.datastatus.push({
                    created_at: obj.created_at,
                    customer_code: obj.customer_code,
                    document_number: obj.document_number,
                    email: obj.email,
                    po_number: obj.po_number,
                    rd_doc_type_display: obj.rd_doc_type_display,
                    rd_doc_type: obj.rd_doc_type,
                    request_status: obj.request_status,
                    id: obj.id,
                    status: obj.status
                });
            });
            _this.loading_main = false;
        });
    };
    DocumentRequestDashboardComponent.prototype.loadDataShow = function () {
        var _this = this;
        this.datastatus = [];
        this.loading_main = true;
        this.customercode;
        var params = new HttpParams();
        params = params.append('page', this.currentPage.toString());
        params = params.append('page_size', this.itemsPerPage.toString());
        this.downloadService.getDocumentRequestList(params).subscribe(function (result) {
            _.forEach(result.results, function (obj) {
                _this.totalItems = result.count;
                _this.datastatus.push({
                    created_at: obj.created_at,
                    customer_code: obj.customer_code,
                    document_number: obj.document_number,
                    email: obj.email,
                    po_number: obj.po_number,
                    rd_doc_type_display: obj.rd_doc_type_display,
                    rd_doc_type: obj.rd_doc_type,
                    request_status: obj.request_status,
                    id: obj.id,
                    status: obj.status
                });
            });
            _this.loading_main = false;
        });
    };
    Object.defineProperty(DocumentRequestDashboardComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (2020) + ':' + (thisYear);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentRequestDashboardComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    DocumentRequestDashboardComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    DocumentRequestDashboardComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    DocumentRequestDashboardComponent.prototype.clearData = function () {
        this.transactions_rejected = null;
        this.transactions_pending = null;
        this.transactions_not_sent = null;
        this.transactions_approve = null;
        this.datastatus = null;
        this.startDate = new Date();
        this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
        this.rdDocumentType = null;
        this.deliverycodeList = null;
        this.customercode = null;
        this.email = null;
        this.documentnum = null;
        this.startDate = null;
        this.endDate = new Date();
        this.startDate = new Date();
        this.sortBy = null;
        this.sortMode = null;
        this.totalItems = null;
        this.checkdate = null;
        this.getEmailReport();
        this.loadTexts();
        this.loadDataShow();
    };
    DocumentRequestDashboardComponent.prototype.selectedType = function (data, status) {
        var _this = this;
        this.datastatus = [];
        this.totalItems = null;
        this.loading_main = true;
        var params = new HttpParams()
            .set('request_status', status);
        this.downloadService.getDocumentRequestList(params).subscribe(function (result) {
            _.forEach(result.results, function (obj) {
                _this.totalItems = result.count;
                _this.datastatus.push({
                    created_at: obj.created_at,
                    customer_code: obj.customer_code,
                    document_number: obj.document_number,
                    email: obj.email,
                    po_number: obj.po_number,
                    rd_doc_type_display: obj.rd_doc_type_display,
                    rd_doc_type: obj.rd_doc_type,
                    request_status: obj.request_status,
                    id: obj.id,
                    status: obj.status
                });
            });
        });
        this.loading_main = false;
    };
    DocumentRequestDashboardComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    return DocumentRequestDashboardComponent;
}());
export { DocumentRequestDashboardComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-request-dashboard/document-request-dashboard.component.ts.pre-build-optimizer.js